export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"de-de","iso":"de","market":"de","lang":"de","countryName":"Deutschland","languageName":"Deutsch"},{"code":"at-de","iso":"de-AT","market":"at","lang":"de","countryName":"Österreich","languageName":"Deutsch"},{"code":"it-it","iso":"it","market":"it","lang":"it","countryName":"Italia","languageName":"Italiano"},{"code":"ro-ro","iso":"ro","market":"ro","lang":"ro","countryName":"România","languageName":"Lb. română"}],
  defaultLocale: "de-de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"de-de","iso":"de","market":"de","lang":"de","countryName":"Deutschland","languageName":"Deutsch"},{"code":"at-de","iso":"de-AT","market":"at","lang":"de","countryName":"Österreich","languageName":"Deutsch"},{"code":"it-it","iso":"it","market":"it","lang":"it","countryName":"Italia","languageName":"Italiano"},{"code":"ro-ro","iso":"ro","market":"ro","lang":"ro","countryName":"România","languageName":"Lb. română"}],
  localeCodes: ["de-de","at-de","it-it","ro-ro"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "}",
}

export const localeMessages = {}
